import React from 'react';
import { NavBarPrimary } from '../../moleculs';

interface AuthLayoutProps {
    children?: React.ReactNode,
    showNavBar?: boolean,
    title?: string
}

const AuthLayout = (props: AuthLayoutProps) => {
    const { children, showNavBar = true, title } = props;
    return (
        <>
            <div className='container'>
                {showNavBar ? <NavBarPrimary title={title} /> : null}
                <div className="page">
                    {children}
                </div>
            </div>
        </>
    );
};

export default AuthLayout;